import { aboutSwiperFunc } from './swiper-custom.js';
import anime from '../../node_modules/animejs/lib/anime.es.js';

//loading animation
window.addEventListener('load', loader);
function loader() {
  let loadingElm = document.querySelector('.loading');

  //timeline
  let tl = anime.timeline({
    easing: 'easeOutExpo',
    duration: 1000,
  });
  tl.add({
    //fade out anime
    targets: '.loading',
    opacity: [1, 0],
    duration: 300,
    easing: 'easeInQuad',
    complete: function () {
      loadingElm.style.display = 'none';
      const main = document.getElementById('mainFadeIn');
      main.style.opacity = 1;
      if (document.querySelector('.hero_swiper')) {
        aboutSwiperFunc();
      }
    },
  });
}

// //nav animation
// const nav = document.querySelector('.hum_nav');
// const navBtn = document.querySelector('.btn-trigger');
// const navBg = document.querySelector('.hum_nav__bg');
// let tlNav = anime.timeline({
//   duration: 500,
//   autoplay: false,
// });
// tlNav
//   .add({
//     targets: '.hum_nav',
//     translateX: [-20, 0],
//     opacity: [0, 1],
//     duration: 300,
//     easing: 'easeOutCubic',
//     begin: function () {
//       nav.style.pointerEvents = 'auto';
//     },
//   })
//   .add({
//     targets: '.hum_nav_box',
//     translateX: ['-100%', 0],
//     duration: 500,
//     easing: 'easeOutCubic',
//   })
//   .add({
//     targets: '.hum_nav li',
//     translateX: [-15, 0],
//     opacity: [0, 1],
//     delay: function (el, i, l) {
//       return i * 100;
//     },
//     duration: 300,
//     autoplay: false,
//     easing: 'easeOutCubic',
//   });
// function toggle() {
//   navBtn.classList.toggle('active');
//   if (tlNav.began) {
//     tlNav.reverse();
//     nav.style.pointerEvents = 'none';
//     // tlNav.finished.then(() => {
//     //   console.log('finished');
//     // });
//     if (tlNav.progress === 100 && tlNav.direction === 'reverse') {
//       tlNav.completed = false;
//     }
//   }
//   if (tlNav.paused) {
//     tlNav.play();
//   }
// }
// navBtn.addEventListener('click', toggle);
// navBg.addEventListener('click', toggle);

// //classでアニメーション
// // const navBtn = document.querySelector('.btn-trigger');
// // const nav = document.querySelector('.hum_nav');
// // const handleClick = () => {
// //   navBtn.classList.toggle('active');
// //   nav.classList.toggle('active');
// // };
// // navBtn.addEventListener('click', handleClick);

// //about text animation
// const aboutTextAnime = anime({
//   targets: '.scroll_anime_area__box',
//   translateX: '-50%',
//   duration: 15000,
//   loop: true,
//   easing: 'linear',
//   autoplay: false,
//   delay: 0,
// });

// // let moveRight = function (entry) {
// //   anime({
// //     targets: entry,
// //     skewX: [30, 0],
// //     opacity: [0, 1],
// //     duration: 1000,
// //     easing: 'easeInOutQuad',
// //   });
// // };

import { ScrollObserver } from './scroll';

//インターセクションオブザーバー

//PC用処理

class MainPC {
  constructor() {
    this._observers = [];
    this._scrollInit();
  }

  _scrollInit() {
    this._observers.push(
      new ScrollObserver('.appear', this._inviewAnimation.bind(this), {
        once: true,
        rootMargin: '0px 0px -500px 0px',
      }),
      new ScrollObserver(
        '.staff_slide_card_swiper',
        this._inviewAnimation2.bind(this),
        {
          once: false, //何度も実行
          rootMargin: '0px 0px -500px 0px',
        }
      ),
      new ScrollObserver(
        '.scroll_anime_area__box',
        this._inviewAnimation3.bind(this),
        {
          once: false,
          rootMargin: '0px 0px -100px 0px',
        }
      )
    );
  }

  _inviewAnimation(el, inview) {
    if (inview) {
      el.classList.add('inview');
    } else {
      el.classList.remove('inview');
    }
  }
  _inviewAnimation2(el, inview) {
    if (inview) {
      // staffSwiper.autoplay.start();
    } else {
      //staffSwiper.autoplay.stop();
    }
  }
  _inviewAnimation3(el, inview) {
    if (inview) {
      //   aboutTextAnime.play();
    } else {
      // aboutTextAnime.pause();
    }
  }
}
//スマホ用処理
class MainSP extends MainPC {
  constructor() {
    super();
  }
  _scrollInit() {
    this._observers.push(
      new ScrollObserver('.appear', this._inviewAnimation.bind(this), {
        once: true,
        rootMargin: '0px 0px -250px 0px',
      }),
      new ScrollObserver(
        '.scroll_anime_area__box',
        this._inviewAnimation3.bind(this),
        {
          once: false,
          rootMargin: '0px 0px 10px 0px',
        }
      )
    );
  }
}

if (window.matchMedia('(max-width: 991px)').matches) {
  //PC
  //オブザーバーAPI
  const main = new MainSP();
} else {
  //sp
  //オブザーバーAPI
  const main = new MainPC();
}
